export type GmEmailAlignment = 'left' | 'center' | 'right';
export type GmEmailHeaderNamePlacement = 'above' | 'left' | 'right' | 'below';

export interface GmEmailHeaderSettings {
  gmEmailHeaderLogoEnabled: boolean;
  gmEmailHeaderNameEnabled: boolean;
  gmEmailHeaderLogoAlignment: GmEmailAlignment;
  gmEmailHeaderNamePlacement: GmEmailHeaderNamePlacement;
  gmEmailHeaderNameAlignment: GmEmailAlignment;
}

function escapeHtml(value: string): string {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function buildGmEmailHeaderHtml(
  settings: GmEmailHeaderSettings,
  schoolName: string,
  schoolLogo: string
): string {
  const logoHtml =
    settings.gmEmailHeaderLogoEnabled && schoolLogo
      ? `<img src="${escapeHtml(schoolLogo)}" alt="${escapeHtml(
          schoolName
        )}" style="max-height:60px;max-width:180px;display:inline-block;height:auto;" />`
      : '';
  const nameHtml =
    settings.gmEmailHeaderNameEnabled && schoolName
      ? `<div style="color:#fff;font-size:20px;font-weight:700;line-height:1.3;">${escapeHtml(schoolName)}</div>`
      : '';

  if (!logoHtml) {
    return nameHtml
      ? `<div style="text-align:${settings.gmEmailHeaderNameAlignment};">${nameHtml}</div>`
      : '';
  }

  if (!nameHtml) {
    return `<div style="text-align:${settings.gmEmailHeaderLogoAlignment};">${logoHtml}</div>`;
  }

  if (settings.gmEmailHeaderNamePlacement === 'above' || settings.gmEmailHeaderNamePlacement === 'below') {
    const nameRow = `<tr><td align="${settings.gmEmailHeaderNameAlignment}" style="text-align:${settings.gmEmailHeaderNameAlignment};">${nameHtml}</td></tr>`;
    const logoRow = `<tr><td align="${settings.gmEmailHeaderLogoAlignment}" style="text-align:${settings.gmEmailHeaderLogoAlignment};">${logoHtml}</td></tr>`;
    const spacer = '<tr><td height="8" style="height:8px;font-size:0;line-height:0;">&nbsp;</td></tr>';
    const rows =
      settings.gmEmailHeaderNamePlacement === 'above'
        ? `${nameRow}${spacer}${logoRow}`
        : `${logoRow}${spacer}${nameRow}`;

    return `<table width="100%" cellpadding="0" cellspacing="0" role="presentation">${rows}</table>`;
  }

  const nameCell = `<td valign="middle" style="vertical-align:middle;text-align:${settings.gmEmailHeaderNameAlignment};">${nameHtml}</td>`;
  const logoCell = `<td valign="middle" style="vertical-align:middle;">${logoHtml}</td>`;
  const spacer = '<td width="14" style="width:14px;font-size:0;line-height:0;">&nbsp;</td>';
  const cells =
    settings.gmEmailHeaderNamePlacement === 'left'
      ? `${nameCell}${spacer}${logoCell}`
      : `${logoCell}${spacer}${nameCell}`;
  const margin =
    settings.gmEmailHeaderLogoAlignment === 'center'
      ? '0 auto'
      : settings.gmEmailHeaderLogoAlignment === 'right'
      ? '0 0 0 auto'
      : '0 auto 0 0';

  return `<table cellpadding="0" cellspacing="0" role="presentation" align="${settings.gmEmailHeaderLogoAlignment}" style="margin:${margin}"><tr>${cells}</tr></table>`;
}
